
import Vue from 'vue'
import Message from '@/components/Message'



const v = new Vue({
    render(createElement){
        return createElement(Message) 
    }
})


v.$mount() //渲染
 
document.body.appendChild(v.$el) //挂载

const load = v.$children[0]

function showMessage(opt){
    load.showMessage(opt)
}
 
export default {
    showMessage
}